export default function Logo({className}: { className?: string }) {
    return <>
        <div className="flex justify-center items-center">
            <img className={`max-w-xs ${className || ''}`} src={process.env.PUBLIC_URL + '/images/logo/omw-logo.png'} alt={'Logo OMW-Energieberatungsbüro'}/>
        </div>
    </>
}